import Svg, { Path } from 'react-native-svg'

export const MailIcon = ({ height = 20, width = 20, color = '#F5F5F5' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
      fill={color}
      d="m10.492 9.45 6.666-4.875a2.5 2.5 0 0 0-1.325-.408H4.167a2.5 2.5 0 0 0-1.359.408L9.475 9.45a.833.833 0 0 0 1.017 0ZM18.2 5.9l-6.733 4.934a2.5 2.5 0 0 1-2.934 0L1.8 5.9a2.35 2.35 0 0 0-.133.767v6.667a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5 2.5 0 0 0 2.5-2.5V6.667A2.35 2.35 0 0 0 18.2 5.9Z"
    />
    </Svg>
  )
}
